import React, { useState } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import { FaShieldAlt, FaLeaf, FaTruck, FaCheckCircle } from "react-icons/fa";

import podSobre from "../assets/podsobre.png";

const SobreHome = () => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setMousePos({
            x: (e.clientX - rect.left) / rect.width - 0.5,
            y: (e.clientY - rect.top) / rect.height - 0.5,
        });
    };
    
    return (
        <Box
            onMouseMove={handleMouseMove}
            sx={{
                marginTop: -20,
                mb: -10,
                width: "100%",
                py: { xs: 8, md: 30 },
                background: "linear-gradient(180deg, var(--backgroundPage), #d8dde6)",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* BACKGROUND DINÂMICO */}
            <Box
                sx={{
                    position: "absolute",
                    top: `calc(50% + ${mousePos.y * 50}px)`,
                    left: `calc(50% + ${mousePos.x * 50}px)`,
                    width: 800,
                    height: 800,
                    background:
                        "radial-gradient(circle, rgba(30,43,78,0.28), rgba(30,43,78,0))",
                    filter: "blur(120px)",
                    transform: "translate(-50%, -50%)",
                    transition: "transform 0.12s linear",
                }}
            />

            <Container maxWidth="xl" sx={{ position: "relative", zIndex: 10 }}>
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    {/* TEXTO ESQUERDA */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            sx={{
                                fontSize: { xs: 32, md: 42 },
                                fontWeight: 800,
                                color: "var(--cinza)",
                                lineHeight: 1.2,
                                width: { xs: "100%", md: "80%" },
                            }}
                        >
                            Descubra uma nova experiência com a EMMA
                        </Typography>

                        <Typography
                            sx={{
                                mt: 3,
                                fontSize: 18,
                                color: "#444",
                                lineHeight: 1.7,
                                maxWidth: 520,
                            }}
                        >
                            Tecnologias modernas, curadoria rigorosa e sabores únicos.
                            Na EMMA, autenticidade e qualidade se unem para entregar uma jornada
                            completa — do clique ao primeiro puff.
                        </Typography>

                        <Typography
                            sx={{
                                mt: 2,
                                fontSize: 16,
                                color: "#555",
                                maxWidth: 520,
                            }}
                        >
                            Nosso compromisso é elevar o padrão dos Pods no Brasil com transparência,
                            segurança e uma curadoria realmente premium.
                        </Typography>
                    </Grid>

                    {/* IMAGEM DIREITA */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{ display: "flex", justifyContent: "center", position: "relative" }}
                    >
                        {/* Glow Animado */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: 380,
                                height: 380,
                                background: "rgba(30,43,78,0.35)",
                                borderRadius: "50%",
                                filter: "blur(90px)",
                                zIndex: 1,
                                transform: `translate(${mousePos.x * 25}px, ${mousePos.y * 25}px)`,
                                transition: "0.15s linear",
                            }}
                        />

                        <img
                            src={podSobre}
                            alt="Pod Premium"
                            style={{
                                width: "380px",
                                position: "relative",
                                zIndex: 2,
                                filter: "drop-shadow(0px 18px 35px rgba(0,0,0,0.25))",
                                transform: `translate(${mousePos.x * 15}px, ${mousePos.y * 15}px)`,
                                transition: "transform 0.15s linear",
                            }}
                        />
                    </Grid>
                </Grid>

                {/* BENEFÍCIOS */}
                <Grid
                    container
                    spacing={4}
                    justifyContent="center"
                    sx={{ mt: 10 }}
                >
                    {[
                        { icon: <FaCheckCircle size={30} />, title: "Qualidade Autêntica" },
                        { icon: <FaShieldAlt size={30} />, title: "Segurança Garantida" },
                        { icon: <FaLeaf size={30} />, title: "Sabores Naturais" },
                        { icon: <FaTruck size={30} />, title: "Entrega Expressa" },
                    ].map((item, i) => (
                        <Grid
                            key={i}
                            item
                            xs={12}
                            sm={6}
                            md={3}
                            sx={{ textAlign: "center" }}
                        >
                            <Paper
                                sx={{
                                    p: 3,
                                    borderRadius: "20px",
                                    height: "140px",
                                    boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                                    transition: "0.3s",
                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                                    },
                                }}
                            >
                                <Box sx={{ color: "var(--azul)", mb: 1 }}>{item.icon}</Box>

                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: 16,
                                        color: "var(--cinza)",
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default SobreHome;
